/* global axios */
import ApiClient from '../ApiClient';

class PilotBuiltinToolsAPI extends ApiClient {
  constructor() {
    super('pilot/builtin_tools', { accountScoped: true });
  }

  getTools() {
    return axios.get(this.url);
  }

  getContactFields() {
    return axios.get(`${this.url}/contact_fields`);
  }

  addContactField(fieldKey) {
    return axios.post(`${this.url}/contact_fields/${fieldKey}`);
  }

  removeContactField(fieldKey) {
    return axios.delete(`${this.url}/contact_fields/${fieldKey}`);
  }

  reorderContactFields(fieldKeys) {
    return axios.put(`${this.url}/contact_fields/reorder`, {
      field_keys: fieldKeys,
    });
  }
}

export default new PilotBuiltinToolsAPI();
